var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import SlickSlider from "react-slick";
import { get } from "lodash";
import withAuth from "@irati/auth/helpers/auth/withAuth";
import authentication from "@irati/auth";
import OnboardingService from "@irati/onboarding/services/onboarding";
import OnboardingStep from "@irati/onboarding/enums/Step";
import tracking from "@irati-tracking/recognition/shared";
import { Slide } from "./styled/Slider";
import { Step1, Step2, Step3 } from "./Steps";
import modalImage from "../../images/onboarding/modalHeader.png";
import { StyledModal } from "./styled/Modal";
var LEGACY_ONBOARDING_STORAGE_KEY = "hideOnboarding";
var Onboarding = /** @class */ (function (_super) {
    __extends(Onboarding, _super);
    function Onboarding() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.slider = null;
        _this.sliderSettings = {
            dots: false,
            infinite: false,
            accessibility: false,
            draggable: false,
            cssEase: "ease-in-out",
            speed: 400,
            slidesToShow: 1,
            arrows: false,
            slidesToScroll: 1,
            swipe: false,
            adaptiveHeight: true,
            className: "onboarding-slider-list"
        };
        _this.state = {
            showModal: false
        };
        _this.neverShowTourAgain = function () { return OnboardingService.completeStep(authentication.user(), OnboardingStep.HAS_COMPLETED_RECOGNITION_WELCOME_TOUR); };
        _this.hide = function (options) {
            _this.neverShowTourAgain();
            var isFinished = get(options, "finished", false);
            tracking.welcomeTutorial(isFinished);
            _this.setState({ showModal: false });
        };
        _this.next = function () {
            if (_this.slider) {
                _this.slider.slickNext();
            }
        };
        return _this;
    }
    Onboarding.prototype.componentDidMount = function () {
        var _this = this;
        // Moved from LocalStorage -> graph (Feb-2020), check kept to avoid double tours
        var showModalLegacyCheck = localStorage.getItem(LEGACY_ONBOARDING_STORAGE_KEY);
        if (!authentication.isUserGhost()) {
            OnboardingService.get(authentication.user().uuid).then(function (res) {
                var showModal = !res.completedSteps.includes(OnboardingStep.HAS_COMPLETED_RECOGNITION_WELCOME_TOUR);
                // If the service thinks the user should see the tour but they have the LocalStorage, fire an update
                if (showModal && showModalLegacyCheck) {
                    _this.neverShowTourAgain();
                    _this.setState({ showModal: false });
                }
                else {
                    _this.setState({ showModal: showModal });
                }
            });
        }
    };
    Onboarding.prototype.render = function () {
        var _this = this;
        var showModal = this.state.showModal;
        return (React.createElement(StyledModal, { show: showModal, image: modalImage },
            React.createElement(SlickSlider, __assign({}, this.sliderSettings, { ref: function (slider) {
                    _this.slider = slider;
                } }),
                React.createElement(Slide, null,
                    React.createElement(Step1, { onNext: this.next, onSkip: this.hide })),
                React.createElement(Slide, null,
                    React.createElement(Step2, { onNext: this.next, onSkip: this.hide })),
                React.createElement(Slide, null,
                    React.createElement(Step3, { onNext: function () { return _this.hide({ finished: true }); } })))));
    };
    return Onboarding;
}(Component));
export default withAuth(Onboarding);
